import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const AboutUsWrapper = styled(PhotographyWrapper)`
  .photo-hero-image { height: auto; max-height: 560px; object-fit: contain; }
  .photo-final-visual img { object-position: center 68%; }
  .about-mission-image { display: block; width: 100%; height: 520px; object-fit: cover; border-radius: 16px; }
  .about-approach { padding-top: 24px; }
  .about-intro { display: grid; grid-template-columns: 1fr 1fr; gap: 56px; align-items: center; }
  .about-intro .photo-title, .about-intro .photo-copy { margin-bottom: 0; }
  .about-coverage .photo-copy { margin-bottom: 20px; }
  .about-values { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 40px; margin-top: 40px; }
  .about-values p { font: 400 17px/1.7 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .about-values .photo-step-number { font-size: 20px; margin-bottom: 14px; }
  .about-services-band { background: #f6f8fc; }
  .about-services { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 36px 40px; margin-top: 40px; }
  .about-service { display: block; text-decoration: none; border-top: 1px solid #cbd5e9; padding-top: 24px; }
  .about-service:hover h3 { color: #2c5bff; }
  .about-service-icon { display: inline-grid; place-items: center; width: 44px; height: 44px; background: #e8eeff; color: #2c5bff; border-radius: 10px; margin-bottom: 18px; }
  .about-service p { font: 400 17px/1.65 'Nunito Sans',sans-serif; color: #52617e; margin: 0 0 14px; }
  .about-service-link { color: #2c5bff; font: 600 16px/1.5 'Nunito Sans',sans-serif; }
  .about-map { margin-top: 32px; }
  .about-map svg { display: block; max-width: 100%; height: auto; }
  @media(max-width:991px) { .about-intro { gap: 32px; } .about-values { gap: 24px; } .about-services { gap: 28px; } }
  @media(max-width:767px) {
    .about-mission-image { height: 360px; }
    .about-approach { padding-top: 0; }
    .about-intro, .about-values { grid-template-columns: 1fr; gap: 24px; }
    .about-values { margin-top: 28px; }
    .about-values article { display: grid; grid-template-columns: 36px 1fr; column-gap: 16px; }
    .about-values .photo-step-number { grid-row: span 2; }
    .about-values h3 { font-size: 19px; margin-bottom: 8px; }
    .about-values p { grid-column: 2; font-size: 16px; }
    .about-services { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 24px 16px; margin-top: 28px; }
    .about-service h3 { font-size: 17px; }
    .about-service p { font-size: 15px; }
    .about-service-link { font-size: 15px; }
    .about-map { margin-top: 24px; }
  }
`;
